import getDefaultHeaders from '@americanexpress/iguazu-resources/utils/getDefaultHeaders';
import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    content,
    locale,
  }, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/hub/${locale?.toLowerCase()}/${content}.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
      headers: {
        Accept: 'application/json',
      },
      ...getDefaultHeaders(),
    },
  }),
};
